module.exports = global["sweetAlert"] = require("-!/Users/lionralfs/Documents/projects/sweetalert/node_modules/expose-loader/index.js?swal!./sweetalert.js");


//////////////////
// WEBPACK FOOTER
// ./sweetalert.js
// module id = 8
// module chunks = 0